export function handelMobile(value) { 
  if (!value) return '';
  if (typeof value !== 'string') value = value.toString();
  return value.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2');
}
